var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4FireHose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 46.39A13.39 13.39 0 1025.61 33 13.41 13.41 0 0039 46.39zm0-22.31A8.92 8.92 0 1130.08 33 8.93 8.93 0 0139 24.08zM35 33a4 4 0 118 0 4 4 0 01-8 0zm24.64 8C57.22 48 50 55.42 39.71 55.42h-.32c-7.13 0-12.76-4.31-15.5-6.91l-.1-.09 1.05-1.16 1.42-2c.13.102.254.212.37.33 4 3.77 8.71 5.87 13 5.81h.12c9.54 0 14.74-7.65 16.15-11.7A18.21 18.21 0 0053 21.87a18 18 0 00-16.41-6.5C27.26 16.58 21 24.82 21 35.87V58h.5a1.5 1.5 0 110 3H21v2l-1 7h-2l-1-7v-2h-.5a1.5 1.5 0 010-3h.5V35.87c0-12.94 7.83-23 19-24.47a22 22 0 0120 7.95A22.42 22.42 0 0159.64 41z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Fire_hose.e3db6979.svg";
export { SvgE4FireHose as ReactComponent };